import React from "react";
import { Badge } from "@chakra-ui/react";
export const ArchivedBadge = () => /* @__PURE__ */ React.createElement(Badge, { textTransform: "none" }, "Archived");
